import { Prompt } from 'react-router-dom'
import { CIMSPromptProps } from './types'

/**
 * wraps a {@link Prompt} to provide a little bit smoother formatting and a default message
 */
const CIMSPrompt: React.FC<CIMSPromptProps> = ({ children, when, message }) => (
  <>
    <Prompt
      when={when}
      message={
        message ??
        'This page has unsaved changes. Are you sure you want to leave?'
      }
    />
    {children}
  </>
)

export default CIMSPrompt
